enum ICardSizes {
	Default = 'default',
	Small = 'small'
}

export default ICardSizes;
